<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ feedbacksQty }} {{ $tc("feedback.feedback", feedbacksQty) }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-feedbacks')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <div v-if="permissions.downloadFeedbacksReport" class="inline">
      &nbsp;
      <button
        class="button"
        @click="$emit('download-feedbacks-report')"
        :style="c1 ? 'margin-top: 1rem;' : ''"
      >
        <b-icon icon="save"></b-icon>
      </button>
    </div>

    <br v-show="c2" />

    <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>
    <span
      :style="
        c1
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block;"
        :placeholder="$t('common.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('common.store')"
        class="inline"
        v-model="store"
        @input="$emit('update-store', store)"
      >
        <option value="">{{ $t("common.allStores") }}</option>
        <option
          v-for="s in orderedStores"
          :key="s._id"
          :value="`${s._id}|${s.storeInfo.name}`"
        >
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["feedbacksQty", "storeId", "storeName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: [],
      store: undefined
    };
  },

  computed: {
    ...mapGetters(["stores", "preferences", "permissions"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    },

    orderedStores() {
      let orderedStores = [];
      if (this.preferences.storesOrder === "alphabetical") {
        orderedStores = [...this.stores].sort((a, b) => {
          return a.storeInfo.name.localeCompare(b.storeInfo.name);
        });
      } else {
        orderedStores = this.stores;
      }
      return orderedStores;
    }
  },

  mounted() {
    this.store = this.storeId ? `${this.storeId}|${this.storeName}` : "";
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
